var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable indent */
import classnames from 'classnames';
import React, { useMemo, useCallback, useState, useEffect, useRef } from 'react';
import { useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import Icon from '../icon';
const prefixCls = createPrefixCls('radio');
export const Radio = (_a) => {
    var { children, className, disabled, defaultChecked, checked, groupValue, formValue, name, color, onChange, setFormValue } = _a, restProps = __rest(_a, ["children", "className", "disabled", "defaultChecked", "checked", "groupValue", "formValue", "name", "color", "onChange", "setFormValue"]);
    const defaultCheckedRef = useRef(defaultChecked);
    const getPropsChecked = useMemo(() => {
        if (groupValue !== undefined) {
            return groupValue === name;
        }
        else if (formValue !== undefined) {
            return formValue;
        }
        else if (checked !== undefined) {
            return checked;
        }
        else {
            return undefined;
        }
    }, [checked, formValue, groupValue, name]);
    const [isChecked, setIsChecked] = useState(getPropsChecked === undefined ? defaultCheckedRef.current || false : getPropsChecked);
    const getIsChecked = useMemo(() => {
        return getPropsChecked === undefined ? isChecked : getPropsChecked;
    }, [getPropsChecked, isChecked]);
    useEffect(() => {
        if (setFormValue && getPropsChecked !== undefined) {
            setFormValue(getPropsChecked);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useUpdate(() => {
        setIsChecked(getPropsChecked || false);
        if (setFormValue && getPropsChecked !== undefined) {
            setFormValue(getPropsChecked);
        }
    }, [getPropsChecked]);
    const handleClick = useCallback(() => {
        if (!disabled && !getIsChecked) {
            setIsChecked(true);
            setFormValue && setFormValue(true);
            onChange && onChange(name === undefined ? true : name);
        }
    }, [disabled, getIsChecked, setFormValue, name, onChange]);
    const radioCls = useMemo(() => {
        return classnames([
            prefixCls(),
            {
                [prefixCls('disabled')]: disabled
            },
            {
                [prefixCls('checked')]: getIsChecked
            },
            className
        ]);
    }, [disabled, getIsChecked, className]);
    return (React.createElement("div", Object.assign({ className: radioCls, onClick: handleClick }, restProps),
        children && React.createElement("div", { className: prefixCls('label') }, children),
        React.createElement(Icon, { name: "success", className: prefixCls('icon'), style: { color } })));
};
export default Radio;
